/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_LoadingInputs */

const en_dropbox_loading = /** @type {(inputs: Dropbox_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading Dropbox…`)
};

const es_dropbox_loading = /** @type {(inputs: Dropbox_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando Dropbox…`)
};

/**
* | output |
* | --- |
* | "Loading Dropbox…" |
*
* @param {Dropbox_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_loading = /** @type {((inputs?: Dropbox_LoadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_LoadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_loading(inputs)
	return en_dropbox_loading(inputs)
});